import { createContext, useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
export const NetworkAlertContext = createContext({} as any);

const NetworkAlertProvider = ({ children }) => {
  const { t: translateText } = useTranslation();
  const [showInfo, setShowInfo] = useState<boolean>(false);
  const [showError, setShowError] = useState<boolean>(false);
  const [infoSpan, setInfoSpan] = useState<string>(
    translateText("network.loadingData")
  );
  const [infoError, setInfoError] = useState<string>(
    translateText("network.loadingData")
  );
  const [error, setError] = useState<boolean>(false);
  const [msgError, setMsgError] = useState<string>("");


  const objMemoProvider = useMemo(
    () => ({
      showInfo,
      setShowInfo,
      showError,
      setShowError,
      infoSpan,
      setInfoSpan,
      infoError,
      setInfoError,
      error,
      setError,
      msgError,
      setMsgError
    }),
    [showInfo, showError, infoSpan, infoError, error, msgError]
  );
  return (
    <div id="divNetworkAlertContext">
      <NetworkAlertContext.Provider value={objMemoProvider}>
        {children}
      </NetworkAlertContext.Provider>
    </div>
  );
};
export default NetworkAlertProvider;
